// extracted by mini-css-extract-plugin
export var sliderRange = "_co-2";
export var sliderRoot = "_co-0";
export var sliderThumb = "_co-3";
export var sliderTrack = "_co-1";